<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">
    <div class="alert alert-danger text-center mb-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>

    <!-- STATUS CARD -->
    <mat-card class="custom-card mt-4" 
      *ngIf="loggedUserPermissions.includes('canCreateSubscriptions')"
      [ngClass]="{'d-none': loggedUserMaster}">
      <mat-card-title>{{ 'properties.detail.statusCard.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'properties.detail.statusCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <div class="alert alert-primary text-center mb-4">
              <mat-slide-toggle class="toggle-activation-btn" color="accent" [checked]="enableEdit"
                (change)="onToggleSelected($event)" matTooltipPosition="right"
                matTooltip="{{ 'companies.detail.contractTab.toggleTooltip' | translate }}">
                <mat-label>{{ 'companies.detail.contractTab.toggleLabel' | translate }}</mat-label>
              </mat-slide-toggle>
            </div>
            <form [formGroup]="formSP" (ngSubmit)="onFormStatusSubmit()">
              <formly-form [form]="formSP" [fields]="statusFields" [model]="modelSP" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div>
          <div>
            <hr />
            <div class="mt-5">
              <strong>{{ 'properties.detail.statement.title' | translate }}</strong>
            </div>
            <div class="mt-2 mb-4">
              <button class="add-icon-button mr-2" color="primary" (click)="onNewStatement()" mat-flat-button
                matTooltip="{{ 'properties.detail.statement.add.title' | translate }}" matTooltipPosition="above">
                {{ 'properties.detail.statement.add.title' | translate }}
              </button>
            </div>
            <div class="table-wrapper">
              <div class="table-toolbar">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-6 col-md-6">
                  </div> 
                  <div class="col-12 col-sm-6 col-md-6 text-right">
                    <button mat-button (click)="onStatementExport()" class="d-none d-sm-inline-block"
                      *ngIf="loggedUserPermissions.includes('canExportBalances')">
                      <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                      {{ 'common.words.export' | translate }}
                    </button>
                    <button mat-button (click)="onResetStatementFilters()" class="d-none d-sm-inline-block">
                      <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                      {{ 'common.cta.resetFilters' | translate }}
                    </button>
                  </div> 
                </div> 
              </div> 
              <div class="spinner-container" *ngIf="statementsDataSource && statementsDataSource.loading$ | async">
                <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
              </div> 
              <div class="table-responsive">
                <table mat-table [dataSource]="statementsDataSource" matSort #statementsSort="matSort" matSortActive="startDate"
                  matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                  <ng-container matColumnDef="index">
                    <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      {{ i + 1 }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                      {{ 'properties.detail.statement.fields.startDate' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.startDate | dateFormat }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                          placeholder="{{ 'common.cta.select' | translate }}" [formControl]="startDateStatementFilter"
                          style="cursor: pointer" />
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetStatementsFilter(startDateStatementFilter)"
                          class="reset-input-icon" *ngIf="startDateStatementFilter.value"></mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                      {{ 'properties.detail.statement.fields.endDate' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.endDate | dateFormat }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                          placeholder="{{ 'common.cta.select' | translate }}" [formControl]="endDateStatementFilter"
                          style="cursor: pointer" />
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetStatementsFilter(endDateStatementFilter)"
                          class="reset-input-icon" *ngIf="endDateStatementFilter.value"></mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="file">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                      {{ 'properties.detail.statement.fields.file' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div *ngIf="element.file && element.file.path">
                        <a class="docLink" href="{{ configService.apiHost }}/{{ element.file.path }}" target="_blank" 
                          matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                          {{ element.file.originalName }}
                        </a>
                      </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="text-right pr-5">
                      {{ 'common.cta.actions' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action pr-3"
                        matTooltip="{{ 'common.cta.open' | translate }}"
                        (click)="onEditStatement(element)">
                      </mat-icon>
                      <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action pr-3"
                        matTooltip="{{ 'common.cta.delete' | translate }}"
                        (click)="onDeleteStatement(element._id)">
                      </mat-icon>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="statementsDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: statementsDisplayedColumns; let i = index;"
                    [class.even-row]="(i % 2) == 0"></tr>
                  <tr mat-footer-row *matFooterRowDef="statementsDisplayedColumns"></tr>
                </table>
                <mat-paginator #statementsPaginator [length]="statementsDataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                  showFirstLastButtons></mat-paginator>
              </div> 
            </div> 
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  
  </div> <!-- /.page-content -->
</div> <!-- /.page -->